import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const TalentDiscoveryService = () => {
  return (
    <IndustryPageTemplate
      title="Talent Discovery"
      subtitle="Connect with amazing talent"
      desc="Discover and connect with amazing talent from around the world. Whether you are casting for a feature film or looking for specialized crew members, our platform brings the best to you."
      image="https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=1000&auto=format&fit=crop"
      themeColor="#07a4f5"
      bgGradient="linear-gradient(135deg, rgba(7,164,245,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Company Registration",
    "desc": "Create verified production company profiles to seamlessly manage casting calls."
  },
  {
    "title": "Audition Management",
    "desc": "Post detailed audition cards, assign roles, and track candidate statuses in real-time."
  },
  {
    "title": "Secure Payments",
    "desc": "Integrated PayU gateway for seamless, secure transactions and billing summaries."
  },
  {
    "title": "Global Location & Roles",
    "desc": "Filter talent by country, assign users to specific projects, and collaborate efficiently."
  }
]}
    />
  );
};

export default TalentDiscoveryService;
